import * as React from 'react';

export const AngleNextIcon = () => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // Decorative — hide from assistive tech and keep out of IE/legacy
    // tab order, matching genesis Icon's unlabeled default.
    aria-hidden="true"
    focusable="false"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4697 12.5318C12.1768 12.2389 12.1768 11.764 12.4697 11.4711L15.4393 8.50147L12.4697 5.5318C12.1768 5.23891 12.1768 4.76404 12.4697 4.47114C12.7626 4.17825 13.2374 4.17825 13.5303 4.47114L17.0303 7.97114C17.3232 8.26404 17.3232 8.73891 17.0303 9.0318L13.5303 12.5318C13.2374 12.8247 12.7626 12.8247 12.4697 12.5318Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.25 8.50146C17.25 8.91568 16.9142 9.25146 16.5 9.25146H2.5C1.5335 9.25146 0.75 8.46796 0.75 7.50146V1.50146C0.75 1.08725 1.08579 0.751465 1.5 0.751465C1.91421 0.751465 2.25 1.08725 2.25 1.50146V7.50146C2.25 7.63954 2.36193 7.75146 2.5 7.75146H16.5C16.9142 7.75146 17.25 8.08725 17.25 8.50146Z"
      fill="currentColor"
    />
  </svg>
);
